import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")<{ isScrolled: boolean }>`
  padding: 0.5rem;
  box-shadow: 1px 0px 3px #ffe839;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999 !important;
  border-right: 1px solid black;
  border-left: 1px solid black;
  transition: background-color 0.3s ease, backdrop-filter 0.3s ease;
  border-bottom: ${({ isScrolled }) =>
    isScrolled ? "2px solid rgb(4, 173, 224)" : "none"};
  background-color: ${({ isScrolled }) =>
    isScrolled ? "#ffe839" : "transparent"};
  backdrop-filter: ${({ isScrolled }) => (isScrolled ? "blur(10px)" : "none")};

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }
`;

export const StyledLogo = styled("span")`
  font-size: 30px;
  color: #18216d;
  display: inline-block;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const Bold = styled("span")`
  font-weight: bold;
`;

export const StyledLogo1 = styled("span")`
  font-size: 30px;
  color: #18216d;
  display: flex;
  flex-direction: column;
  align-items: start;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;
export const SmallW1 = styled("span")`
  font-size: 23px;
  vertical-align: middle;
  margin: 0 2px;

  @media only screen and (max-width: 890px) {
    font-size: 14px !important;
  }
`;

export const Small = styled("span")`
  font-size: 16px;
  vertical-align: middle;
  margin: 0 2px;
`;
export const SmallW = styled("span")`
  font-size: 23px;
  vertical-align: middle;
  margin: 0 2px;

  @media only screen and (max-width: 890px) {
    font-size: 16px !important;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;

  svg {
    fill: #2e186a;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;

  @media only screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;
export const expandFromCenter = keyframes`
  from {
    transform: scaleX(0) rotateX(0);
  }
  to {
    transform: scaleX(1) rotateX(360deg);
  }
`;

export const MenuContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  align-items: center;
  transform-origin: center;
  transform: scaleX(0);
  animation: ${expandFromCenter} 1s forwards ease-out;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #101010;
  transition: color 0.2s ease-in;
  margin: 0 2rem;
  font-weight: 600;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: rgb(10, 10, 10);
    text-underline-position: under;
    text-decoration: rgb(246, 250, 1) wavy underline;
  }
`;
